/** @jsxImportSource @emotion/react */
import { useParams } from 'react-router-dom'
import CalendarBooking from '@components/CalendarBooking'
import { useDesignTokens } from '@hooks/useDesignTokens'
import { TOKENS } from '@gen/tokenConstants'

export default function BookingPage() {
  const { calendarId } = useParams<{ calendarId: string }>()
  const { getValue } = useDesignTokens()

  if (!calendarId) {
    return (
      <div
        css={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          fontFamily: getValue(TOKENS.typography.fontFamily.primary),
        }}
      >
        <div>Calendar ID is required</div>
      </div>
    )
  }

  return (
    <div
      css={{
        minHeight: '100vh',
        backgroundColor: getValue(TOKENS.color.neutral[50]),
        fontFamily: getValue(TOKENS.typography.fontFamily.primary),
      }}
    >
      <CalendarBooking calendarId={calendarId} />
    </div>
  )
}
